/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_RateInputs */

const en_directory_card_rate = /** @type {(inputs: Directory_Card_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate product`)
};

const zh_directory_card_rate = /** @type {(inputs: Directory_Card_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为产品评分`)
};

/**
* | output |
* | --- |
* | "Rate product" |
*
* @param {Directory_Card_RateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_rate = /** @type {((inputs?: Directory_Card_RateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_RateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_rate(inputs)
	return zh_directory_card_rate(inputs)
});
export { directory_card_rate as "directory.card.rate" }